const init = () => {

    var $editList = $('.edit-list');
    if ($editList.length < 1) return;
    $editList.on('click', 'a', function() {
        var $that = $(this);
        var $next = $that.parent().next();
        var isEditing = $next.hasClass('is-editing');
        var newText = isEditing ? 'edit list' : 'cancel';
        $that.text(newText);
        $next.toggleClass('is-editing');

        if (isEditing) {
            // disabled any currently active removal UI as user has tapped cancel
            var $items = $next.find('.remove-toggle.is-active').click();
        }
    });
}

export default init;
